// src/ResetPassword.js
import React, { useMemo, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Layout from "./Components/Layout";
import { api } from "./lib/api";
import styles from "./styles/Auth.module.css";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPassword() {
  const q = useQuery();
  const nav = useNavigate();

  // keep token/email in state, but DO NOT show them as fields
  const [email] = useState(q.get("email") || "");
  const [token] = useState(q.get("token") || "");

  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");

  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setMsg("");

    const emailNorm = String(email || "").trim().toLowerCase();
    const tokenNorm = String(token || "").trim();

    if (!emailNorm || !tokenNorm) {
      setErr("Reset link is missing or invalid. Please request a new reset email.");
      return;
    }

    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");

    setBusy(true);
    try {
      // ✅ baseURL already includes /api, and auth router is mounted at /api/auth
      // so the endpoint is POST /api/auth/reset-password
      const { data } = await api.post("auth/reset-password", {
        email: emailNorm,
        token: tokenNorm,
        newPassword: pw,
      });

      if (!data?.ok) throw new Error(data?.message || "Reset failed");

      setMsg("Password updated. You can now log in.");
      setTimeout(() => nav("/login"), 900);
    } catch (e2) {
      setErr(e2?.response?.data?.message || e2.message || "Reset failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout title="Reset password">
      <form onSubmit={submit} className={styles.form}>
        <h1>Set a new password</h1>

        {/* One row per field */}
        <div style={{ display: "grid", gap: 10 }}>
          <input
            type="password"
            placeholder="New password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            required
            autoComplete="new-password"
          />

          <input
            type="password"
            placeholder="Confirm new password"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            required
            autoComplete="new-password"
          />

          {/* Button at the end */}
          <button disabled={busy}>{busy ? "Saving…" : "Update password"}</button>
        </div>

        {msg && <div className={styles.success}>{msg}</div>}
        {err && <div className={styles.error}>{err}</div>}

        <div style={{ marginTop: 12 }}>
          <Link to="/login">Back to login</Link>
        </div>
      </form>
    </Layout>
  );
}
